import { ChangeDetectionStrategy, Component, computed, input, output } from '@angular/core';
import { OneOnOneChatDelivery, OneOnOneChatMessage } from '@app/one-on-one-chat/model/one-on-one-chat.types';
import { ButtonComponent } from '@app/shared/ui/button/button.component';
import { TranslocoPipe } from '@jsverse/transloco';

@Component({
  selector: 'c-one-on-one-chat-message',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [TranslocoPipe, ButtonComponent],
  templateUrl: './one-on-one-chat-message.component.html',
  styleUrl: './one-on-one-chat-message.component.scss',
})
export class OneOnOneChatMessageComponent {
  readonly message = input.required<OneOnOneChatMessage>();

  readonly retry = output<void>();

  protected readonly hasFailed = computed(() => this.message().delivery === OneOnOneChatDelivery.Failed);
}
